import { RouterOutlet, Routes } from '@angular/router';
import { StoreLayout } from './layouts/store-layout/store-layout';
import { HomePage } from './pages/home-page/home-page';
import { ProductDetails } from './pages/product-details/product-details';
import { CategoryDetails } from './pages/category-details/category-details';
import { CategoriesPage } from './pages/categories-page/categories-page';
import { OrderSuccessPage } from './pages/order-success-page/order-success-page';
import { ShippingAddressPage } from './pages/shipping-address/shipping-address';
import { CheckoutPage } from './pages/checkout-page/checkout-page';
import { ShippingAddressFormComponent } from './pages/shipping-address-form/shipping-address-form';
import { ProductReviewsPage } from './pages/product-reviews/product-reviews-page';
import { ContactUsPage } from './pages/contact-us/contact-us-page';
import { AboutUsPage } from './pages/about-us/about-us-page';
import { ForgotPasswordPage } from './pages/auth-page/forgot-password/forgot-password';
import { EmailVerificationPage } from './pages/auth-page/email-verification/email-verification';
import { ResetPasswordPage } from './pages/auth-page/reset-password/reset-password';
import { ResetSuccessPage } from './pages/auth-page/reset-password/reset-success/reset-success';
import { RegisterSuccessPage } from './pages/auth-page/register-page/register-success/register-success';
import { RegisterPage } from './pages/auth-page/register-page/register-page';
import { InProgressPage } from './pages/in-progress/in-progress-page';
import { SellerProfilePage } from './pages/seller-profile/seller-profile';
import { UserProfilePage } from './pages/user-profile/user-profile-page';
import { OrderDetailsPage } from './pages/user-profile/orders/order-details-page/order-details-page';
import { TicketDetailsPage } from './pages/user-profile/tickets/ticket-details-page/ticket-details-page';
import { OrderTrackingPage } from './pages/order-tracking-page/order-tracking-page';
import { CartPage } from './pages/shopping-cart-page/shopping-cart-page';
import { WishlistPage } from './pages/wishlist/wishlist';
import { SellerReviews } from './pages/seller-profile/seller-reviews/seller-reviews';

export const routes: Routes = [
  {
    path: '',
    component: StoreLayout,
    children: [
      {
        path: 'home/section/:section',
        loadComponent: () =>
          import('./pages/home-section-products/home-section-products').then(
            (m) => m.HomeSectionProducts,
          ),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },

      {
        path: 'auth',
        children: [
          {
            path: 'login',
            loadComponent: () =>
              import('./pages/auth-page/login-page/login-page').then(
                (m) => m.LoginPage,
              ),
          },
          {
            path: 'register',
            children: [
              { path: '', component: RegisterPage },
              { path: 'success', component: RegisterSuccessPage },
            ],
          },
          { path: 'forgot-password', component: ForgotPasswordPage },
          { path: 'email-verification', component: EmailVerificationPage },
          { path: 'reset-password', component: ResetPasswordPage },
          { path: 'reset-success', component: ResetSuccessPage },

          { path: '', redirectTo: 'login', pathMatch: 'full' },
        ],
      },
      {
        path: 'home',
        component: HomePage,
      },
      {
        path: 'news/:slug',
        loadComponent: () =>
          import('./pages/news-detail/news-detail').then((m) => m.NewsDetail),
      },
      {
        path: 'product',
        children: [
          { path: '', redirectTo: '../not-found', pathMatch: 'prefix' },
          { path: ':slug', component: ProductDetails },
        ],
      },
      {
        path: 'categories',
        children: [
          { path: '', component: CategoriesPage },
          {
            path: ':slug',
            children: [
              { path: '', component: CategoryDetails },
              {
                path: ':sub',
                children: [
                  { path: '', component: CategoryDetails },
                  {
                    path: ':sub2',
                    children: [{ path: '', component: CategoryDetails }],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'cart',
        component: CartPage,
      },
      {
        path: 'checkout',
        component: CheckoutPage,
      },
      {
        path: 'shipping-address',
        component: ShippingAddressPage,
      },
      {
        path: 'shipping-address-form',
        component: ShippingAddressFormComponent,
      },
      {
        path: 'order-status',
        component: OrderSuccessPage,
      },

      {
        path: 'order-details/:id',
        component: OrderDetailsPage,
      },
      {
        path: 'ticket-details/:id',
        component: TicketDetailsPage,
      },
      {
        path: 'product-reviews/:productId',
        component: ProductReviewsPage,
      },
      {
        path: 'contact-us',
        component: ContactUsPage,
      },
      {
        path: 'about-us',
        component: AboutUsPage,
      },
      {
        path: 'terms-and-conditions',
        data: { key: 'terms-and-conditions' },
        loadComponent: () => import('./pages/legal-document/legal-document').then((m) => m.LegalDocumentPage),
      },
      {
        path: 'privacy-policy',
        data: { key: 'privacy-policy' },
        loadComponent: () => import('./pages/legal-document/legal-document').then((m) => m.LegalDocumentPage),
      },
      {
        path: 'deals',
        component: InProgressPage,
      },
      {
        path: 'wishlist',
        component: WishlistPage,
      },
      {
        path: 'customer-service',
        component: InProgressPage,
      },
      {
        path: 'seller/:sellerId',
        component: SellerProfilePage,
      },
      {
        path: 'seller/:sellerId/reviews',
        component: SellerReviews,
      },
      {
        path: 'in-progress',
        component: InProgressPage,
      },
      {
        path: 'order-tracking/:id',
        component: OrderTrackingPage,
      },
      {
        path: 'profile/refund-request/:sellerOrderId',
        loadComponent: () =>
          import('./pages/user-profile/refund-request/refund-request-page').then(
            (m) => m.RefundRequestPage,
          ),
      },
      {
        path: 'profile/refunds/:requestId',
        loadComponent: () =>
          import('./pages/user-profile/refunds/refund-detail-page').then(
            (m) => m.RefundDetailPage,
          ),
      },
      {
        path: 'profile',
        component: UserProfilePage,
        children: [
          { path: '', redirectTo: 'my-profile', pathMatch: 'full' },

          {
            path: 'my-profile',
            loadComponent: () =>
              import('./pages/user-profile/profile/profile-page').then(
                (m) => m.ProfilePage,
              ),
          },
          {
            path: 'change-password',
            loadComponent: () =>
              import('./pages/user-profile/change-password/change-password-page').then(
                (m) => m.ChangePasswordPage,
              ),
          },
          {
            path: 'addresses',
            loadComponent: () =>
              import('./pages/user-profile/addresses/shipping-address-page').then(
                (m) => m.ShippingAddressPage,
              ),
          },
          {
            path: 'purchases',
            loadComponent: () =>
              import('./pages/user-profile/purchases/purchases-page').then(
                (m) => m.PurchasesPage,
              ),
          },
          {
            path: 'refunds',
            loadComponent: () =>
              import('./pages/user-profile/refunds/refunds-page').then(
                (m) => m.RefundsPage,
              ),
          },
          // {
          //   path: 'banks-cards',
          //   loadComponent: () => import('./pages/user-profile/sub-pages/banks-cards/banks-cards.component').then(m => m.BanksCardsComponent)
          // },
          {
            path: 'orders',
            loadComponent: () =>
              import('./pages/user-profile/orders/orders-page').then(
                (m) => m.OrdersPage,
              ),
          },
          {
            path: 'wallet',
            loadComponent: () =>
              import('./pages/user-profile/wallet/wallet-page').then(
                (m) => m.WalletPage,
              ),
          },
          {
            path: 'my-reviews',
            loadComponent: () =>
              import('./pages/user-profile/my-reviews/my-reviews-page').then(
                (m) => m.MyReviewsPage,
              ),
          },
          {
            path: 'tickets',
            loadComponent: () =>
              import('./pages/user-profile/tickets/tickets-page').then(
                (m) => m.TicketsPage,
              ),
          },
          {
            path: 'tickets/:id',
            loadComponent: () =>
              import('./pages/user-profile/tickets/ticket-details-page/ticket-details-page').then(
                (m) => m.TicketDetailsPage,
              ),
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import('./pages/user-profile/notifications/notifications-page').then(
                (m) => m.NotificationsPage,
              ),
          },
        ],
      },

      {
        path: 'my-purchases',
        loadComponent: () =>
          import('./pages/my-purchases-page/my-purchases-page').then(
            (c) => c.MyPurchasesPage,
          ),
      },
      // {
      //   path: 'store/:slug',
      //   component: VendorStorePage,
      // },
      {
        path: 'not-found',
        component: RouterOutlet,
      },
      {
        path: '**',
        redirectTo: '/in-progress',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/in-progress',
  },
];
